import { render, staticRenderFns } from "./DocumentFormModal.vue?vue&type=template&id=fd5df0bc&scoped=true&"
import script from "./DocumentFormModal.vue?vue&type=script&lang=js&"
export * from "./DocumentFormModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFormModal.vue?vue&type=style&index=0&id=fd5df0bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5df0bc",
  null
  
)

component.options.__file = "DocumentFormModal.vue"
export default component.exports